(function () {
  angular.module("akitabox.ui.components.preloaders", []);
})();
